import {environmentImports} from './environment/environment';

(async () => {
    await Promise.all(environmentImports)

    // init glide
    const slides = document.querySelectorAll<HTMLElement>('.glide');
    if (slides.length > 0) {
        const { default: Glide, Controls, Breakpoints, Swipe }
            = (await import('@glidejs/glide/dist/glide.modular.esm'))

        const { classes } = (await import('./lib/slider'))
        const { LazyLoading } = (await import('./lib/slider/component/lazyLoading'))

        const sliders = document.querySelectorAll<HTMLElement>('.glide.glide--trip-offer');

        sliders.forEach(slider => {
            new Glide(slider, {
                type: 'carousel',
                perView: 2,
                gap: 0,
                bound: true,
                classes,
                breakpoints: {
                    500: {
                        perView: 1
                    },
                    770: {
                        perView: 2
                    },
                    1023: {
                        perView: 3
                    }
                }
            }).mount({ LazyLoading, Controls, Breakpoints, Swipe });
        });
    }
}) ()
